import React from "react";
import { isNil } from "ramda";

const preferredContactLabels = { Phone: "Phone", Email: "Email" };
type preferredContactKeys = keyof typeof preferredContactLabels;

export const PreferredContact: React.FC<{ value: Maybe<string> }> = ({ value }) => {
  if (isNil(value)) {
    return <></>;
  }
  if (value in preferredContactLabels) {
    return <>{preferredContactLabels[value as preferredContactKeys]}</>;
  }
  return <>{value}</>;
};
